import {Link} from 'react-router-dom'
import Slider from '../components/Slider'
import rentCategoryImage from '../assets/jpg/rentCategoryImage.jpg'
import sellCategoryImage from '../assets/jpg/sellCategoryImage.jpg'


function Explore() {
  return (
    <div className="explore">
      <header>
        <p className="pageHeader">
        
        </p>
      </header>
      <main>
        <Slider />
        <p className="exploreCategoryHeading">
        Categories
        </p>
        <div className="exploreCategories">
          <Link to='/category/rent'>
            <img src={rentCategoryImage} alt="rent" className='exploreCategoryImg' />
            <div className="exploreCategoryName">Places for rent</div>
          </Link>
          <Link to='/category/sale'>
            <img src={sellCategoryImage} alt="sell" className='exploreCategoryImg' />
            <div className="exploreCategoryName">Places for sale</div>
          </Link>
        </div>
      </main>
    </div>
  )
}

export default Explore